// See https://gist.github.com/PhotonEE/7671999
function convolve(vec1, vec2){
    var disp = 0; // displacement given after each vector multiplication by element of another vector
    var convVec = [];
    // for first multiplication
    for (let j = 0; j < vec2.length ; j++){
        convVec.push(vec1[0] * vec2[j]);
    }
    disp = disp + 1;
    for (let i = 1; i < vec1.length ; i++){
        for (let j = 0; j < vec2.length ; j++){
            if ((disp + j) !== convVec.length){
                convVec[disp + j] = convVec[disp + j] + (vec1[i] * vec2[j]);
            }
            else{
                convVec.push(vec1[i] * vec2[j]);
            }
        }
        disp = disp + 1;
    }
    return convVec;
}

function convolveAll(...inputs) {
    // Start with first input
    let output = inputs[0];

    // For each input after the first,
    inputs.slice(1).forEach((input) => {
        // convolve with output in sequence...
        let intermediate = convolve(output, input);
        output = intermediate;
    });

    // ...and return
    return output;
}

export { convolve };
export default convolveAll;


// WEBPACK FOOTER //
// ./src/lib/convolve.js